import { render, staticRenderFns } from "./privilegeTree.vue?vue&type=template&id=6539a4df&scoped=true"
import script from "./privilegeTree.vue?vue&type=script&lang=js"
export * from "./privilegeTree.vue?vue&type=script&lang=js"
import style0 from "./privilegeTree.vue?vue&type=style&index=0&id=6539a4df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6539a4df",
  null
  
)

export default component.exports